var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("注册成功")]),_c('p',[_vm._v("感谢您的注册！您可以继续使用我们的服务。")])])
}]

export { render, staticRenderFns }